module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-181778f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 1385
// module chunks = 1